var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 0C5.79375 0 0.421875 5.37187 0.421875 12V23.25C0.421875 23.6656 0.75625 24 1.17188 24H6.92188C8.025 24 8.92188 23.1031 8.92188 22V15.5C8.92188 14.3969 8.025 13.5 6.92188 13.5H2.67188V12C2.67188 6.61562 7.0375 2.25 12.4219 2.25C17.8062 2.25 22.1719 6.61562 22.1719 12V13.5H17.9219C16.8188 13.5 15.9219 14.3969 15.9219 15.5V22C15.9219 23.1031 16.8188 24 17.9219 24H23.6719C24.0875 24 24.4219 23.6656 24.4219 23.25V12C24.4219 5.37187 19.05 0 12.4219 0ZM6.67188 15.75V21.75H2.67188V15.75H6.67188ZM22.1719 21.75H18.1719V15.75H22.1719V21.75Z",
    fill: "#0A645A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support-icon.187ace0a1509eb8cffcc570b36bb2987.svg";
export { ForwardRef as ReactComponent };